export const PAGE_FETCH = 'page/page_FETCH';
export const PAGE_FETCHED = 'page/page_FETCHED';
export const PAGE_SET_ID = 'page/page_PAGE_SET_ID';
export const PAGE_ERROR = 'page/page_ERROR';
export const PAGE_TITLE = 'page/page_TITLE';
export const SET_PAGE_META_TAGS = 'page/page_META_TAGS';
